const MAX_PRIMARY_YEAR_GROUP = 6;

export function isPrimaryApp({
  yearGroup,
  featureFlagEnabled
}: {
  yearGroup?: number | null;
  featureFlagEnabled: boolean;
}): boolean {
  return featureFlagEnabled;
}
